import React from "react";

import { formatNumber } from "utils";

const Price = ({ value }) => (
  <span className="price-label">{formatNumber(value)}</span>
);

export default Price;
